import { OfflineError } from "@/utils/errors";

const NETWORK_ERROR_CODES = new Set([
  "ERR_NETWORK",
  "ERR_NETWORK_CHANGED",
  "ERR_INTERNET_DISCONNECTED",
  "ECONNABORTED",
  "ETIMEDOUT",
  14,
]);

const isSdkFetchFailure = (error) =>
  error.name === "FetchError" && error.cause?.name !== "AbortError";

export const isNetworkError = (error) => {
  if (!error || error.code === "ERR_CANCELED") return false;
  return (
    NETWORK_ERROR_CODES.has(error.code) ||
    (!!error.isAxiosError && !error.response) ||
    isSdkFetchFailure(error)
  );
};

export const isOfflineFailure = (error) =>
  error instanceof OfflineError || isNetworkError(error);

export const logRequestFailure = (...args) => {
  const error = args.at(-1);
  if (!isOfflineFailure(error)) return console.error(...args);
  console.info(...args.slice(0, -1), error.name);
};

const isTimeout = (error) =>
  error?.code === "ECONNABORTED" || error?.cause?.name === "TimeoutError";

export const isDeviceOfflineFailure = (error) =>
  error instanceof OfflineError ||
  (isNetworkError(error) && (!globalThis.navigator.onLine || isTimeout(error)));

const TRANSIENT_CLIENT_STATUSES = new Set([401, 408, 429]);

export const isTransientFailure = (error) =>
  isOfflineFailure(error) ||
  TRANSIENT_CLIENT_STATUSES.has(error?.response?.status);

export const isRejection = (error) => {
  const status = error?.response?.status;
  return (
    status >= 400 && status < 500 && !TRANSIENT_CLIENT_STATUSES.has(status)
  );
};
